if (!window.__articleCarouselInitialized) {
  window.__articleCarouselInitialized = true;

  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth > 991) {
      initArticleCarousels();
    }
  });

  function initArticleCarousels() {
    document.querySelectorAll(".js-article-products-carousel").forEach((element, index) => {
      if (!element.__splideInstance) {
        const uniqueClass = `js-article-carousel-${String(index + 1).padStart(2, "0")}`;
        element.classList.add(uniqueClass);

        const splide = new Splide(element, {
          type: 'slide',
          drag: 'free',
          gap: '20px',
          perPage: 1,
          arrows: false,
          pagination: true,
        });

        splide.mount();
        element.__splideInstance = splide;
      }
    });
  }
}